module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid default"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4"
  }, [_c('saved-reports')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-8"
  }, [_c('saved-charts')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-748391ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Index.vue
// module id = 404
// module chunks = 0